import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import {faUsers} from "@fortawesome/free-solid-svg-icons";
import {faCalendar} from "@fortawesome/free-solid-svg-icons";
import {faImage} from "@fortawesome/free-solid-svg-icons";
import { IoMdContact } from "react-icons/io";
import { FaBlogger } from "react-icons/fa";
import styles from "./navbardesktop.module.css";
import { FaRegHandshake } from "react-icons/fa";
import { faStore } from "@fortawesome/free-solid-svg-icons";


const Navbardesktop = () => {

    const scrollToTop = () => {
        window.scrollTo(0, 0);
    };

  return (
    <div className={styles.sidebar}>

      {/* LOGO AT TOP */}
      <div className={styles.logo}>
        <img src="./images/TEDx26 Logo.png" alt="App Logo" />
      </div>

      {/* MENU (CENTERED) */}
      <div className={styles.menu}>
        <NavLink to="/" onClick={scrollToTop} className={({ isActive }) =>`${styles.navlink} ${isActive ? styles.active : ""}`}>
            <div className={styles.item}>
              <FontAwesomeIcon icon={faHome} className={styles.icon} />
              <span>Home</span>
            </div>
        </NavLink>

        <NavLink to="/aboutUs" onClick={scrollToTop} className={({ isActive }) =>`${styles.navlink} ${isActive ? styles.active : ""}`}>
            <div className={styles.item}>
              <FontAwesomeIcon icon={faUsers} className={styles.icon} />
              <span>About Us</span>
            </div>
        </NavLink>

        <NavLink to="/events" onClick={scrollToTop} className={({ isActive }) =>`${styles.navlink} ${isActive ? styles.active : ""}`}>
            <div className={styles.item}>
              <FontAwesomeIcon icon={faCalendar}  className={styles.icon} />
              <span>Events</span>
            </div>
        </NavLink>

        <NavLink to="/sponsors" onClick={scrollToTop} className={({ isActive }) =>`${styles.navlink} ${isActive ? styles.active : ""}`}>
            <div className={styles.item}>
              <FaRegHandshake className={styles.icon} />
              <span>Sponsors</span>
            </div>
        </NavLink>

        <NavLink to="/store" onClick={scrollToTop} className={({ isActive }) =>`${styles.navlink} ${isActive ? styles.active : ""}`}>
            <div className={styles.item}>
              <FontAwesomeIcon icon={faStore} className={styles.icon} />
              <span>Store</span>
            </div>
        </NavLink>

        <NavLink to="/blogs" onClick={scrollToTop} className={({ isActive }) =>`${styles.navlink} ${isActive ? styles.active : ""}`}>
            <div className={styles.item}>
              <FaBlogger   className={styles.icon} />
              <span>Blogs</span>
            </div>
        </NavLink>

        <NavLink to="/gallery" onClick={scrollToTop} className={({ isActive }) =>`${styles.navlink} ${isActive ? styles.active : ""}`}>
            <div className={styles.item}>
              <FontAwesomeIcon icon={faImage}  className={styles.icon} />
              <span>Gallery</span>
            </div>
        </NavLink>

        <NavLink to="/contactUs" onClick={scrollToTop} className={({ isActive }) =>`${styles.navlink} ${isActive ? styles.active : ""}`}>
            <div className={styles.item}>
              <IoMdContact size={100} className={styles.icon} />
              <span>Contact Us</span>
            </div>
        </NavLink>

      </div>

    </div>
  );
};

export default Navbardesktop;
